import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Modal } from "../modal/Modal";
import { Button, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  list: {
    paddingLeft: "20px",
    marginBottom: "10px"
  },
  firstItem: {
    marginTop: "10px"
  },
  secondItem: {
    marginTop: "5px"
  }
});

export const RoomEntryErrorModal = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <Modal
      title={<FormattedMessage id="ui-root.entering-error" defaultMessage="Unable to Enter the Verse" />}
      onClose={onClose}
      open={open}
      actions={
        <Button appearance="primary" onClick={onClose}>
          <FormattedMessage id="ui-root.try-again" defaultMessage="Try Again" />
        </Button>
      }
    >
      <p>
        <FormattedMessage
          id="ui-root.entering-error-message"
          defaultMessage="We couldn't connect you to the Verse. This is often due to browser permission issues. Please follow these steps:"
        />
      </p>
      <ol className={classes.list}>
        <li className={classes.firstItem}>
          1.{" "}
          <FormattedMessage
            id="ui-root.entering-error-step-1"
            defaultMessage="Check your browser's permission settings for this website (microphone, camera, motion sensors, xr-spatial-tracking, etc)."
          />
        </li>
        <li className={classes.secondItem}>
          2. <FormattedMessage id="ui-root.entering-error-step-2" defaultMessage="Refresh the page and try again." />
        </li>
      </ol>
    </Modal>
  );
};

RoomEntryErrorModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};
